// Copyright (c) Microsoft. All rights reserved.

export enum AlertType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
